import { render, staticRenderFns } from "./ModalTrainingPlanItem.vue?vue&type=template&id=4b659a01&"
import script from "./ModalTrainingPlanItem.vue?vue&type=script&lang=ts&"
export * from "./ModalTrainingPlanItem.vue?vue&type=script&lang=ts&"
import style0 from "./ModalTrainingPlanItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports